import Cookies from 'universal-cookie';
const cookies = new Cookies();

const isAuthenticated = () => {
  //console.log('in isAuthenticated ()');
  //console.log('cookies', cookies.getAll());

  let user = cookies.get('user');

  //if user isn't present, definitely not logged in, so no point pinging server
  if(user && user.userKey) {
    //console.log('checking server if authenticated');
    return true;
  }
  else {
    return false;
  }
}

const getAuthenticatedUser = () => {
  let user = cookies.get('user');
  if(user) {
    return user;
  }
  else {
    return null;
  }

}

const setAuthentication = (user, persist, exp) => {
  //console.log('setting client auth');
  //console.log('user', user)
  //add persist to user
  user.persist = persist;

  let config = {
    path: '/',
    /*maxAge: exp*/
  };
  if(exp != null){
    config.maxAge = exp;
    //cookies.remove('exp');
  } else {
    //set an expiration to be on safe side
    //this is effectively the max session if browser isn't closed
    //3hrs x 60m x 60s = 10800
    //let tempConfig = config;
    //tempConfig.maxAge = 10800;
    //cookies.set('exp', 10800, tempConfig);
  }
  //cookies.set('userKey', user.userKey, config);
  //cookies.set('user',JSON.stringify(user), config);

  //previous:
  cookies.set('user',user, config);
  //now:
  //localStorage.setItem('user', user);

}

const clearAuthentication = () => {
  /*
  localStorage.removeItem('email');
  localStorage.removeItem('expiration');
  */
  //cookies.remove('userKey');

  cookies.remove('user');
  //localStorage.removeItem('user');
}

export {isAuthenticated, setAuthentication, clearAuthentication, getAuthenticatedUser};
